import React, { useEffect, useState } from "react";
import { getCheckNumberError } from "../../utils/checkNumberValidator";

const LOOKUP_DELAY_MS = 400;

/**
 * Red helper text under a check/cheque number input. Looks the number up while
 * the user types and tells them when it is already used or already entered.
 * Submit/add handlers still validate with validateCheckNumbers.
 *
 * @param {string} value - the check number in the input
 * @param {string[]} [pending] - other check numbers in this form (not saved)
 * @param {string[]} [ignore] - check numbers already saved on this record
 * @param {boolean} [disabled] - skip the lookup (e.g. payment method is Cash)
 */
const CheckNumberError = ({ value, pending = [], ignore = [], disabled }) => {
  const [message, setMessage] = useState("");

  // Arrays are rebuilt every render; compare them by content
  const lookupKey = JSON.stringify([value, pending, ignore, disabled]);

  useEffect(() => {
    if (disabled || !String(value ?? "").trim()) {
      setMessage("");
      return undefined;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const error = await getCheckNumberError(value, { pending, ignore });
        if (!cancelled) setMessage(error?.message || "");
      } catch (error) {
        // Lookup failed: say nothing here, the submit check reports it
        if (!cancelled) setMessage("");
      }
    }, LOOKUP_DELAY_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookupKey]);

  if (!message) return null;
  return (
    <div className="text-danger mt-1" style={{ fontSize: "0.85em" }}>
      {message}
    </div>
  );
};

export default CheckNumberError;
